/** Heure toujours sur 24 h, quel que soit la langue du navigateur. */

export function formatTime24(raw, options = {}) {
  const partial = Boolean(options.partial);
  const text = String(raw ?? "");
  if (!text.trim()) return "";
  const cleaned = text.replace(/[^\d:]/g, "");
  const colon = cleaned.indexOf(":");
  let hours;
  let minutes;
  if (colon >= 0) {
    hours = cleaned.slice(0, colon).replace(/\D/g, "").slice(0, 2);
    minutes = cleaned.slice(colon + 1).replace(/\D/g, "").slice(0, 2);
  } else {
    const digits = cleaned.replace(/\D/g, "").slice(0, 4);
    hours = digits.slice(0, 2);
    minutes = digits.slice(2);
  }
  if (partial) {
    if (!minutes) return hours;
    return `${hours}:${minutes}`;
  }
  if (!hours || minutes.length !== 2) return "";
  const h = Number(hours);
  const m = Number(minutes);
  if (!Number.isInteger(h) || !Number.isInteger(m) || h > 23 || m > 59) return "";
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

export function formatDateTime24(value, options = {}) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("fr-CH", { ...options, hourCycle: "h23" }).format(date);
}

/** Date et heure d'un horodatage serveur, toujours à l'heure de Zurich (ex. 31.10.2026 23:40). */
export function formatStamp(value) {
  return formatDateTime24(value, {
    day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Zurich",
  }).replace(",", "");
}
